class ImageGallery extends HTMLElement {
  connectedCallback() {
    this.#initSwiper();
  }

  #initSwiper() {
    const swiper = this.querySelector(".swiper");
    const slides = this.querySelectorAll(".swiper-slide");
    if (!swiper || !slides) return;

    if (typeof Swiper !== "undefined") {
      new Swiper(swiper, {
        loop: slides.length > 4,
        draggable: true,
        spaceBetween: 24,
        breakpoints: {
          0: {
            slidesPerView: 2.5,
          },
          768: {
            slidesPerView: 3.5,
          },
          1024: {
            slidesPerView: 4.5,
          },
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
      });
    } else {
      requestAnimationFrame(this.#initSwiper.bind(this));
    }
  }
}

if (!customElements.get("image-gallery")) {
  customElements.define("image-gallery", ImageGallery);
}
